const ap_url =
  "https://suntimes-graphics.s3.amazonaws.com/data-storage/elections/2023/general/results/tmp/runoff-results-2023.json";
const ap_ward_url =
  "https://suntimes-graphics.s3.amazonaws.com/data-storage/elections/2023/general/results/tmp/runoff-results-ward-level-2023.json";
const interval = 90;
let tick = interval;

// const wards = [4, 5, 6, 10, 11, 21, 24, 29, 30, 36, 43, 45, 46, 48];
const lead_text = {
  4: {
    text: "State Rep. Lamont Robinson captured just over 46% of the vote in February’s election, falling short of the majority needed to win outright.",
    link: "https://chicago.suntimes.com/elections/2023/3/31/23663506/chicago-4th-ward-candidates-lamont-robinson-prentice-butler",
  },
  5: {
    text: "The potential effects, both benefits and drawbacks, of the impending opening of the Obama Presidential Center in Jackson Park is a major issue for the ward.",
    link: "https://chicago.suntimes.com/elections/2023/3/31/23663507/chicago-5th-ward-candidates-desmon-yancy-tina-hone",
  },
  6: {
    text: "The two candidates, ministers William Hall and Richard Wooten, overlap on several issues, including economic development and the expansion of mental health services.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663068/chicago-6th-ward-candidates-william-hall-richard-wooten",
  },
  10: {
    text: "Ana Guajardo, a labor organizer, won 27% of the vote in February while Peter Chico, a Chicago police officer, won 40%.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663126/chicago-10th-ward-candidates-ana-guajardo-peter-chico",
  },
  11: {
    text: "With former Ald. Patrick Daley Thompson’s conviction, it may seem that the Daley family’s grip on the 11th Ward is slipping. But despite boundary and demographic changes in the ward, the Daleys and their allies are still exerting influence.",
    link: "https://chicago.suntimes.com/elections/2023/3/26/23645253/bridgeport-runoff-11th-ward-lee-ciaravino-patrick-daley-thompson-mayor-richard",
  },
  21: {
    text: "Ronnie Mosley, a longtime community organizer, will face retired firefighter Cornell Dantzler for the 21st Ward seat.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663093/21st-ward-candidates-vow-to-bring-resources-clean-up-neighborhoods-in-community",
  },
  24: {
    text: "Ald. Monique Scott, who was appointed to the role less than a year ago, is facing Creative Scott, a small-business owner and political outsider. While their histories differ, the two candidates share more than the same last name.",
    link: "https://chicago.suntimes.com/2023/3/27/23657706/monique-creative-scott-appointed-west-side-24th-ward-run-off-north-south-lawndale",
  },
  29: {
    text: "Taliaferro, chairman of the City Council’s Public Safety Committee, faces CB Johnson, leader of a nonprofit that helps people recover from drug use. On Feb. 28, Johnson ran strongest in the ward’s lowest-income areas.",
    link: "https://chicago.suntimes.com/elections/2023/3/27/23641269/chicago-runoff-election-chicago-city-council-29th-ward-incumbent-taliaferro-cb-johnson-west-side",
  },
  30: {
    text: "Jessica Gutiérrez, the former policy director of the Puerto Rican Cultural Center and daughter of former U.S. Rep. Luis Gutiérrez, received 38% of the vote in February. Ruth Cruz, an assistant director of admissions at Roosevelt University, got 27%.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663125/chicago-30th-ward-candidates-runoff-jessica-gutierrez-ruth-cruz",
  },
  36: {
    text: "The 36th Ward was redrawn to include more than a handful of communities in a nearly eight-mile stretch of Chicago that includes parts of the West Town, Humboldt Park, Belmont Cragin and Montclare neighborhoods.",
    link: "https://chicago.suntimes.com/2023/3/19/23637922/chicago-election-april-runoff-36th-ward-gil-villegas-lori-torres-whitt-northwest",
  },
  43: {
    text: "Five months after a City Council appointment from Mayor Lori Lightfoot, Ald. Timmy Knudsen only got about a quarter of the vote in February. Now he’s lining up other Democratic support to survive a runoff with Brian Comer.",
    link: "https://chicago.suntimes.com/elections/2023/3/28/23653664/43rd-ward-runoff-timmy-knudsen-brian-comer",
  },
  45: {
    text: "Ald. Jim Gardiner did not respond to the Sun-Times’ requests for an interview about his runoff campaign. Challenger Megan Mathias said many residents complained to her about Gardiner’s inaccessibility but hesitated to donate to her campaign because they “feared retaliation.”",
    link: "https://chicago.suntimes.com/2023/3/24/23650600/scandal-jim-gardiner-reelection-megan-mathias-45th-ward-texts-police-fire-safety-ethics",
  },
  46: {
    text: "Angela Clay, a housing organizer, finished first on Feb. 28 with 36%, while Kim Walz, a Walgreens executive, received about 26%.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663099/candidates-lob-attacks-at-one-another-in-contentious-46th-ward-runoff-race",
  },
  48: {
    text: "Joe Dunne got 26% of the votes in February, compared to 23% for Leni Manaa-Hoppenworth.",
    link: "https://chicago.suntimes.com/elections/2023/4/3/23663097/chicago-48th-ward-candidates-leni-manaa-hoppenworth-joe-dunne",
  },
};

const countdownText = (d) => {
  let duration = moment.duration(d * 1000, "milliseconds");
  return `Updated results in: ${duration.minutes()}:${
    duration.seconds() < 10 ? "0" + duration.seconds() : duration.seconds()
  }`;
};

const meta = d3.select("#elections-2023-runoff #nav").append("section");
const metaTop = d3.select("#elections-2023-runoff #nav .meta-top");
const timestamp = metaTop.select(".timestamp");

const updateMeta = (d) => {
  const date = moment(d).format("LLL");
  timestamp.text(date);
};

const countdown_timer = metaTop
  .select(".countdown")
  .text(countdownText(interval));

const mayor = d3
  .select("#elections-2023-runoff #mayor")
  .append("div")
  .attr("id", "mayor-chicago")
  .attr("class", "container");
mayor.append("h3").text("Mayor of Chicago");
mayor
  .append("p")
  .attr("class", "desc")
  .text(
    "Tuesday’s election is the culmination of a yearlong mayoral election season where attacks have grown increasingly hostile as the two candidates have tried to paint each other as too radical to lead the nation’s third-largest city."
  );
mayor
  .append("a")
  .attr(
    "href",
    "https://www.wbez.org/stories/chicago-election-day-2023/10c8e363-ceb8-49ba-90a1-e6d5f0882dbd"
  )
  .attr("target", "_blank")
  .attr("class", "read-more")
  .text("Read more");
mayor.append("div").attr("class", "reporting");
mayor.append("div").attr("class", "results");

const wards = [4, 5, 6, 10, 11, 21, 24, 29, 30, 36, 43, 45, 46, 48];
wards.map((ward) => {
  const container = d3
    .select("#elections-2023-runoff #alderperson section")
    .append("div")
    .attr("id", `alderperson-ward-${ward}`)
    .attr("class", "container");
  container.append("h3").text(`Ward ${ward}`);
  container.append("p").attr("class", "desc").html(lead_text[ward].text);
  container
    .append("a")
    .attr("class", "read-more")
    .attr("target", "_blank")
    .attr("href", lead_text[ward].link)
    .text("Read more");
  container.append("div").attr("class", "reporting");
  container.append("div").attr("class", "results");
});

const norm = (d) => d.split(" ").join("-").toLowerCase();

const initData = async () => {
  const response = await fetch(ap_url);
  const ward_response = await fetch(ap_ward_url);

  data = await response.json();
  ward_data = await ward_response.json();
  updateMeta(data.timestamp);
  data.races.map((race, i) => {
    const container = d3.select(
      `#${norm(race.officeName)}-${norm(race.seatName)} .results`
    );
    container.selectAll("*").remove();

    const data = race.reportingUnits[0];

    if (data.candidates.length === 1 && race.officeName === "Alderperson") {
      const candidate = data.candidates[0];
      const uncontested = container
        .append("div")
        .attr("class", "uncontested-container")
        .append("div")
        .attr("class", "alderperson uncontested");
      uncontested.append("p").text(`${candidate.first} ${candidate.last}`);
      uncontested.append("span").text("uncontested");
      return;
    }

    if (data.candidates.length <= 3 && race.officeName === "Police Council") {
      const candidate = container
        .selectAll("candidates")
        .data(
          data.candidates.sort((a, b) =>
            a.ballotOrder < b.ballotOrder ? 1 : -1
          )
        )
        .enter();
      const row = candidate
        .append("div")
        .attr("class", "uncontested-container")
        .append("div")
        .attr("class", "alderperson uncontested");
      row.append("p").text((d) => `${d.first} ${d.last}`);
      row.append("span").text("uncontested");
      return;
    }

    const reporting = d3.select(
      `#${norm(race.officeName)}-${norm(race.seatName)} .reporting`
    );
    reporting.selectAll("*").remove();
    reporting
      .append("p")
      .text(
        `${d3.format(",")(data.precinctsReporting)} out of ${d3.format(",")(
          data.precinctsTotal
        )} precincts reporting`
      );
    const rpt_bar = reporting.append("div").attr("class", "rpt-bar");
    rpt_bar
      .append("span")
      .text(d3.format(".1%")(data.precinctsReporting / data.precinctsTotal));
    rpt_bar
      .append("div")
      .attr("class", "precinct-reporting-bar")
      .append("div")
      .style(
        "width",
        d3.format(".1%")(data.precinctsReporting / data.precinctsTotal)
      );
    const table_hed = container.append("div").attr("class", "table_hed");
    table_hed.append("p").text("Candidate").style("grid-area", "candidate");
    table_hed
      .append("p")
      .text("Votes")
      .attr("class", "votes")
      .style("grid-area", "vote");

    table_hed
      .append("p")
      .text("Pct.")
      .attr("class", "pct")
      .style("grid-area", "pct");

    const candidate = container
      .selectAll("candidates")
      .data(
        data.candidates.sort((a, b) => {
          return a.voteCount < b.voteCount ? 1 : -1;
        })
      )
      .enter();
    const totalVotes = d3.sum(data.candidates, (d) => d.voteCount);
    const maxVotes = d3.max(data.candidates, (d) => d.voteCount);
    const row = candidate
      .append("div")
      .attr("class", "row")
      .classed("hidden", (d, i) => i > 3 && race.officeName !== "Mayor");
    container.selectAll(".hidden").style("display", "none");

    row
      .append("div")
      .attr("class", "color-bar")
      .style("background", (d, i) => (i ? "#a578dd" : "#c76c6c"));

    const incumbent = (d) =>
      d.incumbent ? '<span class="incumbent">incumbent</span>' : "";
    row.append("p").html((d) => `${d.first} ${d.last} ${incumbent(d)}`);

    if (race.reportingUnits[0].candidates.length === 1) {
      return row.append("p").text("Uncontested");
    }
    row
      .append("p")
      .attr("class", "votes")
      .text((d) => `${d3.format(",")(d.voteCount)}`);
    row
      .append("div")
      .attr("class", "bar-container")
      .append("div")
      .attr("class", "bar")
      .style("width", (d) =>
        d.voteCount ? d3.format(".1%")(d.voteCount / maxVotes) : "0%"
      )
      .style("background", (d, i) => (i ? "#a578dd" : "#c76c6c"));

    row
      .append("p")
      .attr("class", "pct")
      .text((d) =>
        d.voteCount
          ? `${d3.format(".1%")(d.voteCount / totalVotes)}`
          : `${d3.format(".0%")(0)}`
      );
    const total = container.append("div").attr("class", "total");
    total.append("p").text("Total Votes").style("grid-area", "label");
    total
      .append("p")
      .attr("class", "votes")
      .text(d3.format(",")(totalVotes))
      .style("grid-area", "count");

    if (data.candidates.length > 4 && race.officeName !== "Mayor") {
      let toggle = false;
      const btn = container.append("button").text("Show More");
      btn.on("click", () => {
        toggle = !toggle;
        btn.text(toggle ? "Show Less" : "Show More");
        container
          .selectAll(".hidden")
          .style("display", toggle ? "grid" : "none");
      });
    }
  });

  // const wardResults = d3.select("#mayor-ward");
  // wardResults.selectAll("*").remove();
  // const wardHed = wardResults.append("div").attr("class", "ward-hed");
  // wardHed.append("p").text("Ward");
  // wardHed.append("p").text("Vallas").attr("class", "vallas");
  // wardHed.append("p").text("Johnson").attr("class", "johnson");
  // wardHed.append("p").text("Total votes").attr("class", "total");
  // ward_data.races[0].reportingUnits.map((ward) => {
  //   const row = wardResults.append("div").attr("class", "row");
  //   const totalVotes = d3.sum(ward.candidates, (d) => d.voteCount);
  //   const maxVotes = d3.max(ward.candidates, (d) => d.voteCount);

  //   const vallas = ward.candidates.filter((d) => d.last === "Vallas")[0];
  //   const johnson = ward.candidates.filter((d) => d.last === "Johnson")[0];
  //   row.append("p").text(ward.reportingunitName);
  //   row
  //     .append("p")
  //     .text(d3.format(".0%")(vallas.voteCount / totalVotes))
  //     .attr("class", "votes")
  //     .style("background", maxVotes === vallas.voteCount ? "#c76c6c" : "none");
  //   row
  //     .append("p")
  //     .text(d3.format(".0%")(johnson.voteCount / totalVotes))
  //     .attr("class", "votes")
  //     .style("background", maxVotes === johnson.voteCount ? "#a578dd" : "none");

  //   row.append("p").text(d3.format(",")(totalVotes)).attr("class", "total");
  // });
};

const countdown = () => {
  tick--;
  if (tick < 0) {
    tick = interval;
    initData();
  }
  return countdown_timer.text(countdownText(tick));
};

initData();
setInterval(countdown, 1 * 1000);
